var _link, _link2, _style, _style2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 20,
    height: 20,
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 447.63 447",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    type: "text/css"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    type: "text/css"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    lang: "en",
    type: "text/css"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    lang: "en",
    type: "text/css"
  })), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m231.82 447.05c34.23-4.8633 64.238-40.59 83.121-93.352-27.297-6.1133-55.152-9.3945-83.121-9.7852z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m286.5 438.66c2.0234-0.58594 4.0391-1.1758 6.0391-1.8242 1.6875-0.54297 3.3516-1.1289 5.0156-1.7109 1.9688-0.67969 3.9297-1.3789 5.8828-2.1211 1.6641-0.63281 3.3125-1.3047 4.9648-1.9766 1.9062-0.80078 3.8086-1.5977 5.6914-2.3984 1.6445-0.72266 3.2773-1.4805 4.9102-2.2422 1.8477-0.87109 3.6875-1.7578 5.5117-2.6797 1.6016-0.81641 3.1992-1.6484 4.8008-2.5039 1.793-0.96094 3.5742-1.9414 5.3438-2.9492 1.6016-0.90625 3.1445-1.8164 4.7031-2.7539 1.7344-1.0664 3.4609-2.1328 5.1758-3.1992 1.5352-0.97656 3.0664-1.9688 4.5781-2.9922 1.6875-1.1367 3.3516-2.3203 5.0078-3.5039 1.4883-1.0664 2.9688-2.1289 4.4219-3.1992 1.6016-1.2344 3.2422-2.5117 4.8477-3.793 1.4258-1.1367 2.8477-2.2656 4.25-3.4336 1.5977-1.3281 3.1289-2.7031 4.6797-4.0781 1.3594-1.207 2.7266-2.4023 4.0547-3.6406 1.5273-1.4258 3.0156-2.9023 4.5039-4.3672 1.2891-1.2734 2.5938-2.5273 3.8555-3.832 0.23437-0.24219 0.45703-0.50391 0.69922-0.75391-17.449-9.0117-35.828-16.086-54.816-21.094-9.875 31.492-27.449 60.031-51.129 83.023 0.64844-0.16797 1.2969-0.30469 1.9453-0.47266 1.7109-0.48047 3.3906-1.0078 5.0625-1.5039z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m447.63 231.68h-95.922c-0.36328 37.453-5.7969 74.684-16.152 110.68 21.117 5.6406 41.496 13.75 60.715 24.16 31.555-38.031 49.617-85.449 51.359-134.84z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m231.82 215.68h103.89c-0.40625-36.129-5.707-72.035-15.75-106.74-28.93 6.5977-58.477 10.121-88.145 10.512z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m231.82 0.31641v103.14c27.969-0.39453 55.824-3.6719 83.121-9.7852-18.883-52.762-48.891-88.488-83.121-93.352z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m231.82 327.91c29.668 0.39453 59.215 3.918 88.145 10.516 10.043-34.707 15.344-70.617 15.75-106.75h-103.89z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m396.27 80.844c-19.219 10.41-39.598 18.52-60.715 24.16 10.355 35.996 15.789 73.227 16.152 110.68h95.922c-1.7461-49.387-19.809-96.805-51.359-134.84z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m385.46 68.707c-0.23438-0.23828-0.45703-0.49609-0.6875-0.74219-1.2656-1.3047-2.5781-2.5625-3.8672-3.832-1.4844-1.4648-2.9648-2.9453-4.4961-4.3672-1.3242-1.2344-2.6953-2.4023-4.0547-3.6328-1.5508-1.375-3.1016-2.7617-4.6953-4.0898-1.3828-1.168-2.8008-2.2852-4.207-3.4062-1.6016-1.2969-3.2422-2.5859-4.8906-3.8242-1.4453-1.0898-2.9102-2.1445-4.3828-3.1992-1.6719-1.2031-3.3516-2.4023-5.0547-3.5469-1.4961-1.0078-3.0156-1.9922-4.5352-2.957-1.7305-1.1133-3.457-2.2031-5.2188-3.2578-1.543-0.92578-3.1016-1.8398-4.6641-2.7266-1.7891-1.0234-3.582-2.0156-5.3906-2.9844-1.6016-0.80078-3.1992-1.6719-4.8008-2.4727-1.8398-0.92969-3.6953-1.8242-5.5977-2.7031-1.6016-0.76172-3.2266-1.5039-4.875-2.2266-1.8945-0.83984-3.8086-1.5977-5.7188-2.3984-1.6484-0.67188-3.2891-1.3359-4.9531-1.9688-1.9414-0.74219-3.9102-1.4375-5.8789-2.1172-1.6641-0.58594-3.3281-1.168-5.0156-1.7148-2-0.64844-4-1.2383-6.0547-1.832-1.6641-0.48828-3.3359-0.98438-5.0195-1.4297-0.64453-0.17578-1.3008-0.3125-1.9492-0.48047 23.68 22.992 41.25 51.527 51.129 83.023 19.008-5.0078 37.414-12.086 54.879-21.113z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m0 215.68h95.922c0.36328-37.453 5.7969-74.684 16.148-110.68-21.113-5.6367-41.492-13.746-60.711-24.16-31.555 38.031-49.617 85.453-51.359 134.84z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m215.82 447.05v-103.14c-27.969 0.39453-55.824 3.6719-83.121 9.7852 18.879 52.762 48.891 88.488 83.121 93.352z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m215.82 231.68h-103.89c0.40625 36.129 5.7031 72.039 15.75 106.75 28.93-6.6016 58.473-10.125 88.145-10.516z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m215.82 0.31641c-34.23 4.8633-64.242 40.59-83.121 93.352 27.297 6.1172 55.152 9.3945 83.121 9.7852z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m215.82 119.45c-29.668-0.39062-59.215-3.9141-88.145-10.512-10.047 34.707-15.344 70.613-15.75 106.74h103.89z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m168.11 6.7891c-0.64844 0.16797-1.2969 0.30469-1.9453 0.47266-1.6953 0.45312-3.3672 0.95703-5.0547 1.4453-2.0078 0.58594-4 1.1758-6.0156 1.8164-1.6992 0.55078-3.3711 1.1367-5.043 1.7188-1.957 0.69141-3.918 1.3789-5.8555 2.1133-1.6719 0.64062-3.3203 1.3047-4.9766 1.9844-1.9023 0.80078-3.8086 1.6016-5.6875 2.3984-1.6484 0.72266-3.2773 1.4805-4.9102 2.2422-1.8477 0.87109-3.6875 1.7578-5.5117 2.6797-1.6016 0.81641-3.2031 1.6523-4.8008 2.5039-1.793 0.96094-3.5703 1.9453-5.3359 2.9531-1.6016 0.89453-3.1758 1.8125-4.7188 2.75-1.7383 1.0469-3.457 2.1289-5.168 3.1992-1.5391 0.98438-3.0664 1.9766-4.5781 3-1.6875 1.1367-3.3516 2.3203-5.0078 3.5039-1.4883 1.0664-2.9688 2.1289-4.4258 3.2031-1.6367 1.2305-3.1992 2.5117-4.8477 3.7891-1.4219 1.1367-2.8555 2.2656-4.2461 3.4414-1.6016 1.3203-3.1211 2.6875-4.6641 4.0547-1.3672 1.2188-2.7461 2.4023-4.082 3.6641-1.5195 1.418-3 2.8906-4.4844 4.3516-1.2891 1.2734-2.6016 2.5312-3.8672 3.8398-0.23047 0.24219-0.45312 0.50781-0.69531 0.75391 17.445 9.0156 35.828 16.09 54.816 21.098 9.875-31.477 27.438-59.996 51.105-82.977z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m66.719 383.23c1.4883 1.4648 2.9688 2.9453 4.4961 4.3711 1.3281 1.2305 2.6953 2.3984 4.0586 3.6289 1.5508 1.3789 3.1016 2.7617 4.6953 4.0898 1.3828 1.1602 2.793 2.2812 4.207 3.4062 1.6016 1.2969 3.1992 2.5859 4.8945 3.832 1.4414 1.082 2.9062 2.1289 4.3711 3.2031 1.6719 1.1992 3.3594 2.3984 5.0625 3.5508 1.4961 1.0078 3.0156 1.9922 4.5352 2.9609 1.7305 1.1094 3.457 2.1992 5.2188 3.2539 1.543 0.92969 3.1016 1.8398 4.6641 2.7305 1.7891 1.0234 3.582 2.0156 5.3906 2.9805 1.5977 0.80078 3.1992 1.6719 4.8008 2.4727 1.8398 0.92969 3.6953 1.8242 5.5977 2.707 1.6016 0.75391 3.2266 1.4961 4.875 2.2227 1.8945 0.83984 3.8047 1.5977 5.7188 2.3984 1.6484 0.67188 3.2891 1.3359 4.9531 1.9688 1.9414 0.74609 3.9102 1.4414 5.8789 2.1211 1.6641 0.58203 3.3281 1.168 5.0156 1.7109 2 0.64844 4 1.2422 6.0547 1.832 1.6641 0.48828 3.3359 0.98438 5.0156 1.4336 0.64844 0.17578 1.3047 0.3125 1.9531 0.48047-23.68-22.996-41.25-51.531-51.129-83.027-18.988 5.0117-37.371 12.086-54.816 21.105 0.23438 0.23828 0.45703 0.49609 0.69141 0.74219 1.1992 1.2969 2.4922 2.5547 3.7969 3.8242z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m51.359 366.52c19.219-10.41 39.598-18.52 60.711-24.16-10.352-35.996-15.785-73.227-16.148-110.68h-95.922c1.7461 49.387 19.805 96.805 51.359 134.84z",
    fill: "currentColor",
    style: {},
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.ba01710e.svg";
export { ForwardRef as ReactComponent };